import * as actions from './saleMaster/actions'
import * as mutations from './saleMaster/mutations'
import * as getters from './saleMaster/getters'

import { dataProps, itemListProps } from './saleMaster/properties'

const state = {
    list: null,
    order_tab: '1',
    showCategoryWindow: false,
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.created_at',
        sort_direction: 1, 
        search_term: '', 
        search_term_array: []
    },
    show_category: [],
    items: {
        total_rows: 0,
        item_sub_category_id: 0,
        item_type: -1,
        offset: 0,
        list: []//all items         
    },
    fabric: null,
    props: JSON.parse(JSON.stringify(dataProps)),
    temp_order_item: null,
    item_autocomplete_list: [],
    sale_type: -1,
    outstanding_list: [],
    print: {
        showPrintWindow: false,
        printSrc: '',
        printTitle: ''
    },
    dummy_list_item: JSON.parse(JSON.stringify(itemListProps)),
    showWorkOrder: false,
    selectedRowData: null,
    sales_cost_sheet: [],
    trial_schedule_list: []
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/saleMaster.js